// extracted by mini-css-extract-plugin
export default {"btnContainer":"SMRButton_btnContainer__6-ISf","inline":"SMRButton_inline__2Mpin"};